import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([])); }, []);
  if (!posts) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-500" /></div>;
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Blog</h1>
      <p className="text-slate-600 mt-2 mb-8">Tadilat ipuçları, fiyat rehberleri ve usta seçim önerileri.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden hover-lift" data-testid={`blog-card-${p.slug}`}>
            {p.cover && <img src={p.cover} alt={p.title} className="w-full h-44 object-cover" />}
            <div className="p-5">
              <span className="text-xs font-bold text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-full">{p.category}</span>
              <h3 className="text-lg font-bold text-slate-900 mt-3">{p.title}</h3>
              <p className="text-sm text-slate-500 mt-1 line-clamp-2">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
